// Loads a user's avatar as a cached data: URL. `staleTime: Infinity` means a
// photo is fetched once per session (or until a caller invalidates
// ['avatar', userId] after an upload/delete) — the bytes don't change on
// their own, so there is nothing to poll for.

import { useQuery } from '@tanstack/react-query'

import { fetchAvatarDataUrl } from './avatar.js'

/** `hasAvatar` gates the fetch: skip the network round-trip entirely for a
 *  person with no photo, so every initials-only avatar in a list doesn't
 *  fire (and 404) a request. Returns the data: URL, or undefined while
 *  loading / when there is no photo. */
export function useAvatar(
  userId: string | undefined,
  hasAvatar: boolean | undefined,
): string | undefined {
  const { data } = useQuery({
    queryKey: ['avatar', userId],
    queryFn: () => fetchAvatarDataUrl(userId!),
    enabled: userId !== undefined && hasAvatar === true,
    staleTime: Infinity,
    gcTime: 30 * 60_000,
  })
  return data ?? undefined
}
